import { useEffect, useState } from 'react'
import { Box, Stack, Grid, Paper, SvgIcon, Typography } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import custom from '../../styles/mui/szVariables.json'

export default function LeftNavigation(
    { 
      itemSelected, 
      title, 
      navItemList,
      defaultSelected
    }: any
  ) {
    const [selected, setSelected] = useState(itemSelected || defaultSelected);
    const border = custom.border
    const colorSelected = "primary.main";

    useEffect(() => {
      if( selected !== itemSelected ) {
        setSelected(itemSelected)
      }
    },[selected, itemSelected])

    const menuItems = (items: any[]) => (
      <>
        {items.map((item:any,i:number)=>(
          <Box sx={{ 
                    width: '100%', 
                    cursor: 'pointer', 
                    '&:hover': {
                      backgroundColor: 'sz.colors.hover',
                      boxShadow: 'none',
                      borderRadius: i===(items.length-1)?'0 0 10px 10px':0 
                    }, 
                  }}
                  id={item.id} 
                  key={item.id} 
                  onClick={item.action}
                  >
              <Stack alignItems="start" direction="row" 
                  justifyContent="flex-center" 
                  py={custom.spacing.sm}
                  pl={custom.spacing.sm}>
                  <Stack alignItems="center" direction="row" 
                      justifyContent="flex-start">
                      <SvgIcon viewBox='0 0 24 24' 
                          sx={{ color: `${item.id===selected?
                                      colorSelected:item.id!=='signout'?
                                      'inherit':'error.main'}`
                              }}> 
                          {item.id===selected?item.selected:item.iconPath} 
                      </SvgIcon>
                      <Typography
                        pl={custom.spacing.xxs} 
                        variant="szHeading.Regular.xSmall" 
                        sx={{ 
                          color: `${item.id===selected?
                            colorSelected:item.id!=='signout'?
                            'inherit':'error.main'}`  }}>
                              {item.name}
                      </Typography>
                  </Stack>
                  {item.id!=='signout'?
                  <ArrowForwardIosIcon sx={{ 
                      ml: 'auto', 
                      mr: custom.spacing.xxs, 
                      height: '20px', 
                      color: `${item.id===selected?colorSelected:'inherit'}` 
                  }}/>:<></>}
              </Stack>
          </Box>
        ))}
      </>
    )


    return (
      <Grid container direction="column" 
          justifyContent="flex-start"
          maxWidth={"100%"}
          pl={custom.spacing.md}>
          <Grid item xs maxWidth={"100%"}>
            <Paper elevation={0}  sx={{ 
                  borderRadius: custom.corners4,
                  border: border,
                  boxSizing: 'border-box',  
                  minWidth:"210px"
                }} >
                <Box 
                  px={custom.spacing.sm}
                  pt={custom.spacing.sm}
                  pb={custom.spacing.xs}>
                    <Typography component={"h2"} 
                      variant='szHeading.Bold.xSmall'>
                      {title}
                    </Typography>
                </Box>   
                {menuItems(navItemList)}
            </Paper>
          </Grid>
      </Grid>
    )
}